import {
  ChangeDetectionStrategy,
  Component, effect,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {OfferService} from '../../../service/offer.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {NgbDatepicker} from '@ng-bootstrap/ng-bootstrap';
import {IconComponent} from '../../icon/icon.component';
import {TranslatePipe} from '@ngx-translate/core';
import {
  MaintenanceVehicleSignalStore
} from '../../../../maintenance/vehicle/maintenance-vehicle.signal-store';

@Component({
  selector: 'ucs-expiring-offer-calendar',
  templateUrl: './expiring-offer-calendar.component.html',
  styleUrls: ['./expiring-offer-calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbDatepicker, IconComponent, TranslatePipe]
})
export class ExpiringOfferCalendarComponent implements OnInit, OnDestroy, OnChanges {
  @Input() currentChannel: DistributionChannel;
  expirationsPerDay: { [index: string]: number } = {};
  activeAuctionOffers: number;
  activeBuyNowOffers: number;
  private offerService = inject(OfferService);
  private readonly maintenanceVehicleStore = inject(MaintenanceVehicleSignalStore);
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor() {
    effect(() => {
      if (this.maintenanceVehicleStore.userSubstitutions() 
          && this.currentChannel && this.currentChannel === 'PB') {
        this.getExpiringOffersCount();
      }
    });
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (propName === 'currentChannel') {
        this.getExpiringOffersCount();
      }
    }
  }

  ngOnInit(): void {
    this.getExpiringOffersCount();
  }

  getNumOfExpiringOffers(date: any): number {
    const formattedDate = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
    return this.expirationsPerDay[formattedDate] || 0;
  }

  getExpiringOffersCount() {
    this.offerService.getExpiringOffersCount(this.currentChannel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        if (data) {
          this.expirationsPerDay = data.expirationsPerDay;
          this.activeAuctionOffers = data.totalActiveAuctions;
          this.activeBuyNowOffers = data.totalActiveBuyNowOffers;
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
